<template>
<svg :width="width" :height="height" viewBox="0 0 22 22" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 16.2144L9 17.7144H13H17L21 20.0001V12.0001V8.0001L20.5 7.4287L18 4.9287" stroke="#008FD1" stroke-:width="2"/>
<path d="M1 8V14.2768L3.50386 12.846L3.73444 12.7143H4H8H11.6301L13.3492 11.2407L15 9.8258V6.8571V3.88851L13.3492 2.47354L11.6301 1H8H4.4082L1.22726 4.116L1 4.3757V8Z" stroke="#008FD1" stroke-:width="2"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 22 },
        height: { type: [Number, String], default: 22 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
